var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M18.778 4.684a7.347 7.347 0 0 1-2.095.565 3.607 3.607 0 0 0 1.604-1.987 7.371 7.371 0 0 1-2.316.872A3.67 3.67 0 0 0 13.308 3c-2.014 0-3.647 1.608-3.647 3.59 0 .282.032.555.095.819a10.411 10.411 0 0 1-7.518-3.752 3.53 3.53 0 0 0-.494 1.806c0 1.245.644 2.344 1.623 2.988a3.68 3.68 0 0 1-1.652-.45v.046c0 1.74 1.256 3.19 2.925 3.52a3.722 3.722 0 0 1-1.647.062A3.645 3.645 0 0 0 6.4 14.122a7.39 7.39 0 0 1-4.53 1.537 7.57 7.57 0 0 1-.87-.05 10.44 10.44 0 0 0 5.591 1.613c6.71 0 10.377-5.47 10.377-10.215 0-.156-.003-.311-.01-.465a7.324 7.324 0 0 0 1.82-1.858z"}));
}

TwitterInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
